const collegeConfig = {
  // College Information
  collegeName: "Sri Aurobindo Institute of Medical Sciences",
  shortName: "Saims",
  appName: "E-Logbook System",
  
  // Contact Information
  supportEmail: "support@saims.com",
  adminContact: "admin@saims.com",
  
  // Branding
  logo: require('../components/assets/logo.png'),
  favicon: '/favicon.ico',
  
  // Theme Colors (Inspired by Logo - Orange, Red & Gold)
  theme: {
    // Primary (main sun red from logo)
    primaryColor: '#b11217',
    primaryColorLight: '#d63a3f',
    primaryColorDark: '#7f0c10',

    // Secondary (deep crimson outline of logo)
    secondaryColor: '#8c0f12',
    secondaryColorLight: '#b42a2e',
    secondaryColorDark: '#5e0709',

    // Accent (soft red tint for highlights)
    accentColor: '#f2b3b5',

    // Highlight (UI interaction color)
    highlightRed: '#d63a3f',

    // Status colors
    successColor: '#2e8b57',
    warningColor: '#f4a261',
    errorColor: '#c44536',
    infoColor: '#b11217',

    // Backgrounds (clean academic UI)
    backgroundColor: '#fafafa',
    backgroundGradient: 'linear-gradient(135deg, #fafafa 0%, #f2f4f7 100%)',
    cardBackground: '#ffffff',

    // Text
    textPrimary: '#1f2933',
    textSecondary: '#4a5568',
    textLight: '#7a8794',

    // Borders & shadows
    borderColor: '#e5e7eb',
    shadowColor: 'rgba(0,0,0,0.05)',
  },
  
  // Demo Videos (relative to /public — set to null to hide the Watch Demo button)
  demoVideos: {
    login:   '/assets/videos/login-demo.mp4',
    student: '/assets/videos/student-demo.mp4',
    teacher: '/assets/videos/prof-demo.mp4',
  },

  // App Store Links
  // Set to null to show "Coming Soon", or provide the full store URL
  appLinks: {
    android: 'https://play.google.com/store/apps/details?id=com.saims.elogbook', // e.g. 'https://play.google.com/store/apps/details?id=com.yourapp'
    ios: 'https://apps.apple.com/us/app/saims-e-logbook/id6763109428',     // e.g. 'https://apps.apple.com/app/your-app/id1234567890'
  },

  // Feature flags
  features: {
    forgotPassword: true,
    rememberMe: false
  },

  // App Settings
  version: '1.2.0',
  copyrightYear: '2026',
  
  // API Endpoints
  api: {
    baseURL: process.env.REACT_APP_API_URL || 'https://elogbook.saimsonline.com/api',
    timeout: 10000,
  },
};

// Export theme as CSS variables for easy use in CSS files
export const generateCSSVariables = () => {
  const variables = {};
  Object.entries(collegeConfig.theme).forEach(([key, value]) => {
    const cssVarName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
    variables[cssVarName] = value;
  });
  return variables;
};

export default collegeConfig;